import { DetailFormComponentsEnum } from "@/lib/enum/detail-form-components.enum";
import { Filter, FilterConfig, FilterTypes, IsFilterable } from "@/lib/filterable";
import { Form, FormConfig, IsFormable } from "@/lib/formable";
import { parsePhone } from "@/lib/utility/parsePhone";
import { RulesEnum } from "@/lib/rules/rules.map";
import { MrfiktivContactDocumentGen, MrfiktivPartialContactDocumentGen } from "@/services/mrfiktiv/v1/data-contracts";
import { CountryCodeEnum } from "@/lib/enum/country-code.enum";

@IsFormable
@IsFilterable
class ContactBase implements MrfiktivContactDocumentGen {
  /**
   * @inheritdoc
   */
  @FormConfig({
    category: "common.nouns.contact",
    searchKeywords: ["objects.contact.email", "common.nouns.contact"],
    type: DetailFormComponentsEnum.TEXT_FIELD,
    props: {
      label: "objects.contact.email"
    },
    rules: [RulesEnum.REQUIRED_RULE, RulesEnum.EMAIL_RULE]
  })
  @FilterConfig({ type: FilterTypes.STRING, displayName: "objects.contact.email" })
  email: string;
  /**
   * @inheritdoc
   */
  _phone?: string;

  _countryCode?: CountryCodeEnum;

  /**
   * Get the phone number in international format
   * @inheritdoc
   */
  @FormConfig({
    category: "common.nouns.contact",
    searchKeywords: ["objects.contact.phone", "common.nouns.contact"],
    type: DetailFormComponentsEnum.TEXT_FIELD,
    props: { label: "objects.contact.phone" },
    rules: [RulesEnum.REQUIRED_RULE, RulesEnum.PHONE_RULE]
  })
  @FilterConfig({ type: FilterTypes.STRING, displayName: "common.nouns.contact" })
  get phone(): string {
    return this._phone ?? "";
  }

  /**
   * Set the phone number and transform it to international format using libphonenumber
   * @param value Phone number to set
   */
  set phone(value: string) {
    this._phone = parsePhone(value, this._countryCode);
  }

  constructor(contact?: Partial<MrfiktivPartialContactDocumentGen>, countryCode?: CountryCodeEnum) {
    this._countryCode = countryCode;
    this.email = contact?.email ?? "";
    this.phone = contact?.phone ?? "";
  }

  get dto(): MrfiktivContactDocumentGen {
    return {
      email: this.email,
      phone: this.phone
    };
  }
}

type IContact = ContactBase;
const Contact = Form.createForClass(Filter.createForClass(ContactBase));

export { Contact, IContact };
